import {Injectable} from '@angular/core';
import {AccountService} from 'app/core/auth/account.service';
import {AlertService} from 'app/common/alert/alert.service';
import {ENTITY_SROUCE_ENTITY_IMPORT, ENV, SERVER_API_URL} from 'app/app.constants';
import {HttpClient} from '@angular/common/http';
import {ImportResult} from 'app/main/private/setup/import-data/model/import-result.model';

declare let CSVBoxImporter: any;

@Injectable({
    providedIn: 'root'
})
export class CsvBoxUtilsService {
    constructor(
        private accountService: AccountService,
        private _alertService: AlertService,
        private http: HttpClient
    ) {}

    getCsvBoxImporter(csvBoxLicenceKey: string, flags: any = {}, resourceName: string, onCsvUploadComplete?: (data, flags) => void): any {
        flags.entitySource = ENTITY_SROUCE_ENTITY_IMPORT;
        const importer = new CSVBoxImporter(csvBoxLicenceKey, {}, (result, data) => {
            if (importer.isModalShown) {
                if (result) {
                    console.log(data.row_success + ' rows uploaded from CSV');
                    onCsvUploadComplete(data, flags);
                } else {
                    this._alertService.showError('There was some problem uploading the sheet');
                    console.error('There was some problem uploading the sheet');
                }
            }
        });

        this.accountService
            .get()
            .toPromise()
            .then((account) => {
                importer.setUser({
                    user_id: account.body.email,
                    email: account.body.email,
                    tenant: account.body.tenantId,
                    flags: btoa(JSON.stringify(flags)),
                    env: ENV
                });
            });
        return importer;
    }

    onImportResult(): void {}
}
